import { useQuery } from "@tanstack/react-query";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";

const path = `${baseUrl}/tag-type`;

export const { useGetAll: useAllTagType, useGet: useTagType } = apiCrudBuilder(
  path,
  "TagType",
  { staleTime: 3600000, cacheTime: 3600000 }, // 1 hour
);

export const useTagTypeList = (tagTypeId, options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["TagType", tagTypeId, "tag-list"],
    queryFn: () =>
      appAxios.get(`${path}/${tagTypeId}/taglist/`).then((res) => {
        return res.data;
      }),
    staleTime: 3600000,
    cacheTime: 3600000, // 1 hour
  });
};

const tagPath = `${baseUrl}/tag`;

export const { useGetAll: useAllTag, useGet: useTag } = apiCrudBuilder(
  tagPath,
  "Tag",
  { staleTime: 3600000, cacheTime: 3600000 }, // 1 hour
);
